module.exports = __webpack_public_path__ + "img/couples_03_V.5a58300a.webp";